// Frontend Supabase client. Uses the publishable/anon key; all data access is
// guarded by row-level security on the server side.
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// Fail loudly at startup on a misconfigured deploy. Without this, a missing env
// var slips through as `undefined` and surfaces much later as a cryptic network
// error the first time auth is used — a confusing failure for the user and a
// hard one to diagnose. A clear message here points straight at the cause.
if (!url || !anonKey) {
  throw new Error(
    "Missing Supabase configuration: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY at build time.",
  );
}

export const supabase = createClient(url, anonKey);
